import { render, staticRenderFns } from "./CopyTextField.vue?vue&type=template&id=0ccbbb73"
import script from "./CopyTextField.vue?vue&type=script&lang=ts"
export * from "./CopyTextField.vue?vue&type=script&lang=ts"
import style0 from "./CopyTextField.vue?vue&type=style&index=0&id=0ccbbb73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports